import styles from "./Privacy.module.scss";
import MenuSection from "../Home/MenuSection";
import { Container } from "react-bootstrap";
import Footer from "../Home/Footer";
import { PrivacySection } from "./PrivacySection/PrivacySection";

const Privacy = () => {
  return (
    <Container fluid className={styles.Privacy}>
      <MenuSection />
      <Container className={styles.contentWrapper}>
        <PrivacySection />
      </Container>
      <Footer />
    </Container>
  );
};

export default Privacy;
